<template>
  <svg
    class="icon-chevron-down"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M17.8194 9L11.9097 15.4608L6 9" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" />
  </svg>
</template>

<script setup lang="ts"></script>

<style lang="scss">
.icon-chevron-down {
  display: block;
  stroke: var(--theme-icon-chevron-down-color);
}
</style>
